import { queryClient } from '@core/query'
import { FollowQueryKey } from './queryKeys'

export const resetFollowers = (username: string) => {
    queryClient.invalidateQueries({
        queryKey: FollowQueryKey.followers(username),
        exact: true,
    })
}

export const resetFollowing = (username: string) => {
    queryClient.invalidateQueries({
        queryKey: FollowQueryKey.following(username),
        exact: true,
    })
}
